<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.coOrganisers.addTitle' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'manageEvent.coOrganisers.addDescription' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <!-- Company Search Section -->
    <div class="row mb-4">
      <div class="col-12">
        <label class="form-label">{{ 'manageEvent.coOrganisers.searchCompany' | translate }} <span class="text-danger">*</span></label>
        <div class="position-relative">
          <app-input-component
            [type]="'text'"
            [placeholder]="'manageEvent.coOrganisers.searchPlaceholder' | translate"
            [value]="companySearch"
            (valueChange)="onSearchInput($event)"
            [disabled]="selectedCompany != null"
            [invalid]="isCompanyInvalid"
          />
          <div *ngIf="selectedCompany" class="selected-company-badge mt-2">
            <span class="badge bg-primary d-inline-flex align-items-center gap-2">
              <i class="fa fa-building"></i>
              {{ selectedCompany.company_name }}
              <i class="fa fa-times cursor-pointer" (click)="clearSelectedCompany()"></i>
            </span>
          </div>
          <div *ngIf="showResults && companySearchResults.length > 0" class="search-results-dropdown">
            <div *ngFor="let company of companySearchResults"
                 class="search-result-item"
                 (click)="selectCompany(company)">
              <div class="d-flex align-items-center">
                @if (company.company_logo_url) {
                  <img [src]="company.company_logo_url" class="rounded-circle me-2" width="32" height="32" alt="">
                } @else {
                  <i class="fa fa-building me-2"></i>
                }
                <div>
                  <div class="fw-medium">{{ company.company_name }}</div>
                  @if (company.city) {
                    <small class="text-muted">{{ company.city }}</small>
                  }
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isSearching" class="search-loading">
            <i class="fa fa-spinner fa-spin"></i> {{ 'common.searching' | translate }}
          </div>
          <div *ngIf="showResults && companySearchResults.length === 0 && !isSearching && companySearch.length >= 2" class="search-no-results">
            {{ 'manageEvent.coOrganisers.noCompaniesFound' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- Access Level Section -->
    <div class="row">
      <div class="col-12">
        <label class="form-label">{{ 'manageEvent.coOrganisers.selectAccessLevel' | translate }} <span class="text-danger">*</span></label>
        <div class="d-flex flex-column gap-3">
          @for (option of accessLevelOptions; track option.value) {
            <div
              class="access-level-option p-3 rounded border cursor-pointer"
              [class.border-primary]="accessLevel === option.value"
              [class.bg-light-primary]="accessLevel === option.value"
              (click)="accessLevel = option.value"
            >
              <div class="d-flex align-items-start">
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    [id]="'access-' + option.value"
                    [value]="option.value"
                    [(ngModel)]="accessLevel"
                    name="accessLevel"
                  >
                </div>
                <div>
                  <label [for]="'access-' + option.value" class="form-label mb-1 fw-semibold cursor-pointer">
                    {{ option.label | translate }}
                  </label>
                  <p class="text-muted small mb-0">{{ option.description | translate }}</p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'neutral'"
          [label]="'common.cancel' | translate"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : ('manageEvent.coOrganisers.addCoOrganiser' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
